import React from 'react';
import {Container, Row, Col, Alert} from 'react-bootstrap';
import { useAppContext } from '../libs/contextLib';

export default function ErrorBar({
  ...props
}) {
  const { errors, setError } = useAppContext();
  
  function closeError(error) {
    error.severity = 'resolved'
    setError(error)
  }

  function getAlerts() {
    return errors.map((error, idx) => (
      <Alert
        key={idx}
        variant={error.severity === 'persist' ? 'danger' : error.severity}
        dismissible
        onClose={() => closeError(error)}
      >
        {error.message}
      </Alert>
    ));
  }

  // Return an empty component if there are no errors.
  return (
    <>
    {
      errors.length > 0
        ? 
      <Container fluid="sm" className='mt-3'>
        <Row>
          <Col >{ getAlerts() }</Col>
        </Row>
      </Container>
      :
      <></>
    } 
    </>
  )
}